module.exports = __webpack_public_path__ + "static/media/poly4.ff085166.jpg";